import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Home, BookOpen, Leaf, Users, ArrowLeft, LogOut, CreditCard, Sparkles, LayoutDashboard } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { Brand, ThemeToggle } from "@/components/hm/Basics";
import { SiteFooter } from "@/components/hm/SiteFooter";
import { openPortal } from "@/lib/billing";

const NAV = [
  { to: "/inicio", label: "Inicio", icon: Home, id: "inicio" },
  { to: "/academia", label: "Academia", icon: BookOpen, id: "academia" },
  { to: "/recursos", label: "Recursos", icon: Leaf, id: "recursos" },
  { to: "/comunidad", label: "Comunidad", icon: Users, id: "comunidad" },
];

const AccountMenu = () => {
  const { user, signOut } = useAuth();
  const nav = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="avatar-btn" data-testid="account-menu-trigger" aria-label="Mi cuenta">
        <span className="avatar">{user.name.charAt(0).toUpperCase()}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-2xl">
        <DropdownMenuLabel>
          <p className="text-sm font-semibold">{user.name}</p>
          <p className="text-xs font-normal text-muted-foreground">{user.email}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="menu-my-plan" onClick={() => (user.has_subscription ? openPortal() : nav("/planes"))}>
          <CreditCard className="mr-2 h-4 w-4" /> {user.has_subscription ? "Gestionar mi plan" : "Ver los planes"}
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="menu-journal" onClick={() => nav("/inicio#diario")}>
          <Sparkles className="mr-2 h-4 w-4" /> Mi diario de claridad
        </DropdownMenuItem>
        {user.role === "admin" && (
          <DropdownMenuItem data-testid="menu-admin" onClick={() => nav("/admin")}>
            <LayoutDashboard className="mr-2 h-4 w-4" /> Panel de administración
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="logout-button" onClick={signOut}>
          <LogOut className="mr-2 h-4 w-4" /> Salir
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default function AppLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const goBack = () => (window.history.state?.idx > 0 ? navigate(-1) : navigate("/inicio"));
  return (
    <div style={{ minHeight: "100svh" }}>
      <header className="app-top">
        <div className="wrap app-top-in">
          <Brand to="/inicio" />
          <nav className="app-links" aria-label="Principal">
            {NAV.map((n) => <NavLink key={n.id} to={n.to} data-testid={`topnav-${n.id}`}>{n.label}</NavLink>)}
          </nav>
          <div className="app-act"><ThemeToggle /><AccountMenu /></div>
        </div>
      </header>
      <main className="app-main">
        {pathname !== "/inicio" && (
          <button onClick={goBack} className="back-btn" data-testid="back-button"><ArrowLeft size={16} /> Volver</button>
        )}
        <Outlet />
      </main>
      <SiteFooter inApp />
      <div style={{ height: 70 }} className="lg:hidden" />
      <nav className="bottom-nav" data-testid="bottom-nav">
        <div className="bottom-nav-in">
          {NAV.map((n) => (
            <NavLink key={n.id} to={n.to} data-testid={`bottomnav-${n.id}`}><n.icon size={20} strokeWidth={1.8} />{n.label}</NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
